import { Box, Grid, Typography } from "@mui/material";
import { formatNumber } from "../options";

const ListProductRecommended = ({
  productRecommended,
  brand,
  isMobile = false,
}) => {
  return (
    <Box
      display={"flex"}
      width={"100%"}
      height={"100%"}
      padding={"12px 36px"}
      overflow={"scroll"}
      sx={{
        "&::-webkit-scrollbar": {
          display: "none",
        },
        "-ms-overflow-style": "none",
        "scrollbar-width": "none",
      }}
    >
      {productRecommended.map((item) => {
        return (
          <>
            <Grid
              minWidth={isMobile ? "220px" : "220px"}
              padding={"10px 24px"}
              marginRight={"12px"}
              borderRadius={"12px"}
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              justifyContent={"center"}
              style={{
                backgroundColor: brand.background,
                border: `1px solid ${brand.color}`,
              }}
            >
              <Typography
                color={brand.color}
                variant="h5"
                textAlign={"center"}
                fontSize={isMobile ? "12px" : "16px"}
              >
                {item.name}
              </Typography>
              <Box display={"flex"} alignItems={'center'}>
                <Typography
                  color={brand.color}
                  variant="h5"
                  textAlign={"center"}
                  fontSize={isMobile ? "12px" : "16px"}
                >
                  ${formatNumber(item.price)}
                </Typography>
                {item.value_discount != null ||
                  (item.value_percent != null && (
                    <Box backgroundColor={"red"} marginLeft={'10px'} borderRadius={'12px'} padding={'2px 6px'}>
                      <Typography
                        color={"white"}
                        variant="h5"
                        fontSize={isMobile ? "12px" : "16px"}
                      >
                        {item?.value_discount
                          ? `-$ ${formatNumber(item.value_discount)}`
                          : `-${item.value_percent}%`}
                      </Typography>
                    </Box>
                  ))}
              </Box>
            </Grid>
          </>
        );
      })}
    </Box>
  );
};

export default ListProductRecommended;
